/**
 * After a product accordion opens, sync layout to full content height (deferred
 * images, fonts) so <details> panels are not clipped with inner scrollbars.
 */
(function () {
  function bindImages(panel, details) {
    panel.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        'load',
        () => {
          if (details.open) syncPanel(details);
        },
        { once: true },
      );
    });
  }

  function syncPanel(details) {
    const panel = details.querySelector('.accordion__content');
    if (!panel || !details.open) return;

    panel.style.removeProperty('max-height');
    panel.style.removeProperty('height');
    void panel.offsetHeight;
    bindImages(panel, details);
  }

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.closest('.product__accordion')) return;
      if (!details.open) return;
      requestAnimationFrame(() => syncPanel(details));
    },
    true,
  );
})();
